<template>
    <div class="pt-3">
        <div v-if="!isSubmited" v-loading="isLoading">
            <div class="text-center" style="width: 100%; max-width: 600px; margin: 0 auto;">
                <h5><strong>Spread the Word - Claim Your {{currentItem.bonusAmount}}{{ currentItem.bonusUnit }} Reward</strong></h5>
                <p style="word-break: break-word;">Love rendering with us? Share your job/project on social media, tag
                    iRender, and receive a <strong>{{currentItem.bonusAmount}}{{ currentItem.bonusUnit }}</strong> coupon as a thank-you gift!</p>
            </div>
            <div class="mt-6" style="width: 100%; max-width: 700px; margin: 0 auto;">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" label-position="left">
                    <el-form-item label="Username" prop="username">
                        <el-input v-model="ruleForm.username" placeholder="Username" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="Social Media Link" prop="socialMediaLink">
                        <el-input v-model="ruleForm.socialMediaLink" placeholder="Please paste the URL of your public post/check-in here"></el-input>
                    </el-form-item>
                </el-form>
                <div class="text-center mb-3">
                    <button class="primary-button-style-2026 px-12 py-2" @click="submitForm('ruleForm')"
                        type="button">
                        Submit
                    </button>
                </div>
            </div>
        </div>
        <div v-if="isSubmited" class="pb-3">
            <div class="text-center" style="width: 100%; max-width: 800px; margin: 0 auto;">
                <div class="mb-5">
                    <img src="/img/checked.svg" height="50"/>
                </div>
                <h5><strong>Success! Your request is being processed.</strong></h5>
                <div class="mt-7">
                    <p style="word-break: break-word;">Thank you for sharing your amazing [work/post] with the iRender
                        community! <br />
                        Our team is currently verifying your submission.</p>
                    <p style="word-break: break-word;">Your <strong>{{currentItem.bonusAmount}} {{ currentItem.bonusUnit }}</strong> coupon will be manually added to your
                        account within 1 hour.</p>
                </div>
                <div>
                    <el-button @click="$router.push('/dashboard')">
                        Back to Dashboard
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import promotionApi from '@/api/promotionApi';
import { EXECUTE_RESULT } from "@/constant/baseConstant";
export default {
    props: {
        currentItem: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            isSubmited: false,
            isLoading: false,
            ruleForm: {
                username: '',
                socialMediaLink: '',
            },
            rules: {}
        };
    },
    computed: {
        ...mapState({
            user: state => state.auth.user
        }),
    },
    watch: {
        user(){
            this.ruleForm.username = this.user.username;
        }
    },
    created() {
        this.ruleForm.username = this.user.username;
        this.rules = {
            username: [
                { required: true, message: 'Please enter username', trigger: 'blur' },
                { min: 3, message: 'Your username is too short', trigger: 'blur' },
                { max: 20, message: 'Username cannot exceed 20 characters', trigger: 'blur' },
                {
                    pattern: /^[a-zA-Z0-9]{3,20}$/,
                    message: 'Username must be 3-20 characters and contain only letters and numbers',
                    trigger: 'blur'
                }
            ],

            socialMediaLink: [
                { required: true, message: 'Please enter social media link', trigger: 'blur' },
                { validator: this.validateUrl, trigger: 'blur' }
            ]
        }
    },
    methods: {
        validateUrl(rule, value, callback) {
            if (!value) return callback()

            // basic but solid URL check
            const isValid = /^(https?:\/\/)([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/.test(value)

            if (!isValid) {
                return callback(new Error('Please enter a valid URL'))
            }

            callback()
        },
        async submitCouponShowcase(payload) {
            this.isLoading = true;
            const res = await promotionApi.submitCouponShowcase(this.currentItem.code, payload);
            if (res) {
                const data = res.data;
                if (data.result === EXECUTE_RESULT.SUCCESS) {
                    this.$message.success("Submit successfully!");
                    this.isSubmited = true;
                    this.isLoading = false;
                    this.$emit('onRequestReloadList');
                } else {
                    this.$message.error(data.message || "Submit failed!");
                    this.isLoading = false;
                }
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitCouponShowcase({
                        couponVoucherId: this.currentItem.id,
                        ...this.ruleForm
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    },
    mounted() {
        console.log("currentItem in popup: ", this.currentItem);
    }
}
</script>